import SignUpForm from '../components/SignUp/Form'
import SignUpVerify from '../components/SignUp/Verify'
import SignUpSuccess from '../components/SignUp/Success'

export default [
  {
    path: '/client/sign-up',
    name: 'sign-up',
    component: SignUpForm,
    props: {
      topNotice: [],
    },
  },
  {
    path: '/client/narasumate',
    name: 'sign-up-narasumate',
    props: {
      mateFormType: 'mate',
      title: 'narasuMateアカウント登録',
    },
    component: SignUpForm,
  },
  {
    path: '/client/narasulife',
    name: 'sign-up-narasulife',
    props: {
      mateFormType: 'life',
      title: 'narasuLifeアカウント登録',
    },
    component: SignUpForm,
  },
  {
    path: '/client/sign-up/:token',
    name: 'sign-up-company',
    props: {
      isCompany: true,
    },
    component: SignUpForm,
  },
  {
    path: '/client/sign-up/verify/:token',
    name: 'sign-up-verify',
    component: SignUpVerify,
  },
  {
    path: '/client/signup-success',
    name: 'sign-up-success',
    component: SignUpSuccess,
  },
]
